export default __webpack_public_path__ + "static/media/fromToArrow.c1db4760.svg";